<template>

  <div id="global-modal"
    class="global-modal is-visible"
    v-if="isVisible && contents"
  >

    <div class="global-modal__inner">
      <div v-show="loaded" v-if="contents.video" class="responsive-iframe">
        <iframe v-on:load="onLoaded" :src="contents.video" allowfullscreen="" frameborder="0" title="SCI-Arc video iframe"></iframe>
      </div>
      <figure v-else v-show="loaded">
        <img v-on:load="onLoaded" :alt="contents.alt" :src="imageUrl"/>
        <figcaption>
          <p v-if="contents.student" class="global-modal__caption">{{contents.student}}</p>
          <p v-if="contents.className" class="global-modal__caption">{{contents.className}}</p>
          <p v-if="contents.program" class="global-modal__caption">{{contents.program}}</p>
          <p v-else-if="contents.title" class="global-modal__caption">{{contents.title}}</p>
        </figcaption>
      </figure>
      <div v-if="!loaded">Loading</div>
    </div>

    <div class="global-modal__close">
      <button @click="hide" tabindex="0">Close</button>
    </div>

  </div>
</template>

<script>
import { EventBus } from '../event-bus.js';

export default {
  name: 'GlobalModal',

  data () {
    return {
      isVisible: false,
      contents: [],
      loaded: false
    }
  },

  mounted () {
    EventBus.$on('open-global-modal', e => {
      this.show(e)
    })

    EventBus.$on('close-global-modal', e => {
      this.hide()
    })
  },

  methods: {
    hide () {

      if (typeof Wistia !== 'undefined') {
        let allVideos = Wistia.api.all();

        for (var i = 0; i < allVideos.length; i++) {
          allVideos[i].play();
  
          const videoControlButton = document.querySelector('button.control-button');
          if(videoControlButton) {
            videoControlButton.innerHTML = '<img src="/assets/images/icons/icon-pause.png" alt="Pause background video">';
          }
        }
      }
	
	
	    var modalPopup = document.querySelector('#global-modal');
	    modalPopup.removeAttribute('tabindex');
      document.body.removeEventListener('keyup', this.handleEsc);
      this.isVisible = false;
  
      var isModalIframe = document.querySelector('#global-modal .responsive-iframe');
      var isModalImage = document.querySelector('#global-modal figure>img');
      
      if(isModalIframe) {
        document.querySelector('.js-play-video-button').focus();
      } else if(isModalImage) {
        var imageContainer = document.querySelector('#student-work .student-work-item.focus-on-modal-exit');
        imageContainer.focus();
      }
    },

    show (e) {
      this.isVisible = true;
      this.contents = e;
      
	    setTimeout(function() {
		    var modalPopup = document.querySelector('#global-modal');
		    modalPopup.setAttribute('tabindex', -1);
		    modalPopup.focus();
	    }, 500);

      document.body.addEventListener('keyup', this.handleEsc);
  
      if(e.thumb) {
        /*Clear active items*/
        var items = document.getElementsByClassName('student-work-item focus-on-modal-exit');
        while (items[0]) {items[0].classList.remove('focus-on-modal-exit')}
        /*Set image focus*/
        var image = document.querySelector('#student-work img.student-work-item__image[src*="' + e.thumb + '"]');
        image.closest('.student-work-item').classList.add('focus-on-modal-exit');
      }
    },

    handleEsc (e) {
      if (e.keyCode === 27) {
        EventBus.$emit('close-global-modal');
      }
    },

    onLoaded () {
      this.loaded = true;
    }
  },

  computed: {
    imageUrl () {
      if (this.contents.thumb) {
        return this.contents.thumb
      } else if (this.contents.image) {
        return this.contents.image
      } else return
    }
  }
}

</script>
